import {
  createTableColumn,
  Link,
  TableColumnDefinition,
} from "@fluentui/react-components";
import { IEmail } from "../../../Models/IEmails";

interface IEmailColumnsProps {
  onClickedEmail(item: IEmail): void;
}

export function EmailColumns(props: IEmailColumnsProps) {
  const columns: TableColumnDefinition<IEmail>[] = [
    createTableColumn<IEmail>({
      columnId: "to",
      compare: (a, b) => {
        return a.to.localeCompare(b.to);
      },
      renderHeaderCell: () => {
        return "An";
      },
      renderCell: (item: IEmail) => {
        return <div>{item.to}</div>;
      },
    }),
    createTableColumn<IEmail>({
      columnId: "subject",
      compare: (a, b) => {
        return a.subject.localeCompare(b.subject);
      },
      renderHeaderCell: () => {
        return "Betreff";
      },
      renderCell: (item: IEmail) => {
        return (
          <Link onClick={() => props.onClickedEmail(item)}>{item.subject}</Link>
        );
      },
    }),
    createTableColumn<IEmail>({
      columnId: "sent",
      compare: (a, b) => {
        return a.sent.localeCompare(b.sent);
      },
      renderHeaderCell: () => {
        return "Gesendet";
      },
      renderCell: (item: IEmail) => {
        return <div>{new Date(item.sent).toLocaleString()}</div>;
      },
    }),
  ];
  return columns;
}
